function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_generator(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype), d = Object.defineProperty;
    return d(g, "next", {
        value: verb(0)
    }), d(g, "throw", {
        value: verb(1)
    }), d(g, "return", {
        value: verb(2)
    }), typeof Symbol === "function" && d(g, Symbol.iterator, {
        value: function() {
            return this;
        }
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { orderBy } from 'lodash';
import userApi from '../api/userApi';
import { makeAutoObservable, observable } from 'mobx';
import { Roles } from '../models/Roles';
export var RoleStore = /*#__PURE__*/ function() {
    "use strict";
    function RoleStore() {
        var _this = this;
        _class_call_check(this, RoleStore);
        _define_property(this, "roles", []);
        _define_property(this, "role", new Roles());
        _define_property(this, "isLoading", true);
        _define_property(this, "error", '');
        _define_property(this, "fetchAllRoles", function() {
            return _async_to_generator(function() {
                var r, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                3,
                                4
                            ]);
                            this.setIsLoading(true);
                            return [
                                4,
                                userApi.roles.getAll()
                            ];
                        case 1:
                            r = _state.sent();
                            this.setRoles(orderBy(r.data, [
                                function(roles) {
                                    return roles.name.toLowerCase();
                                }
                            ]));
                            return [
                                3,
                                4
                            ];
                        case 2:
                            error = _state.sent();
                            console.error(error);
                            return [
                                3,
                                4
                            ];
                        case 3:
                            this.setIsLoading(false);
                            return [
                                7
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }).call(_this);
        });
        _define_property(this, "fetchRoleById", function(roleId) {
            return _async_to_generator(function() {
                var response, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                3,
                                4
                            ]);
                            this.setIsLoading(true);
                            return [
                                4,
                                userApi.roles.getRole(roleId)
                            ];
                        case 1:
                            response = _state.sent();
                            this.setRole(response.data);
                            return [
                                3,
                                4
                            ];
                        case 2:
                            error = _state.sent();
                            console.error(error);
                            return [
                                3,
                                4
                            ];
                        case 3:
                            this.setIsLoading(false);
                            return [
                                7
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }).call(_this);
        });
        _define_property(this, "createRole", function(role) {
            return _async_to_generator(function() {
                var response, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                3,
                                4
                            ]);
                            this.setIsLoading(true);
                            return [
                                4,
                                userApi.roles.create(role)
                            ];
                        case 1:
                            response = _state.sent();
                            this.setRole(response.data);
                            return [
                                3,
                                4
                            ];
                        case 2:
                            error = _state.sent();
                            console.error(error);
                            return [
                                3,
                                4
                            ];
                        case 3:
                            this.setIsLoading(false);
                            return [
                                7
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }).call(_this);
        });
        _define_property(this, "updateRole", function(roleId, role) {
            return _async_to_generator(function() {
                var response, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                3,
                                4
                            ]);
                            this.setIsLoading(true);
                            return [
                                4,
                                userApi.roles.update(roleId, role)
                            ];
                        case 1:
                            response = _state.sent();
                            this.setRole(response.data);
                            return [
                                3,
                                4
                            ];
                        case 2:
                            error = _state.sent();
                            console.error(error);
                            return [
                                3,
                                4
                            ];
                        case 3:
                            this.setIsLoading(false);
                            return [
                                7
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }).call(_this);
        });
        _define_property(this, "deleteRole", function(roleId) {
            return _async_to_generator(function() {
                var error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                userApi.roles.delete(roleId)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            console.log(error);
                            this.error = 'Failed to remove Role';
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            }).call(_this);
        });
        makeAutoObservable(this);
    }
    _create_class(RoleStore, [
        {
            key: "setRoles",
            value: function setRoles(value) {
                this.roles = value;
            }
        },
        {
            key: "setRole",
            value: function setRole(value) {
                this.role = value;
            }
        },
        {
            key: "setIsLoading",
            value: function setIsLoading(value) {
                this.isLoading = value;
            }
        }
    ]);
    return RoleStore;
}();
_ts_decorate([
    observable
], RoleStore.prototype, "error", void 0);
